import { makeStyles } from "@material-ui/core/styles";
const theme = (props) => {
  const styles = makeStyles(theme => ({
    backContainer: {
      margin: '0px -10px',
      width: 'calc(100% + 20px)',
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: 20,
      '& button': {
        maxWidth: 140,
      }
    },
    tableContainer: {
      margin: '0px -10px',
      width: 'calc(100% + 40px)',
    },
    clientBox: {
      padding: 10,
      marginRight: 5,
      marginBottom: 10,
      color: '#989898',
      fontWeight: 200,
      fontSize: 13,
      '& .title': {
        fontSize: 20,
        fontWeight: 400,
        marginBottom: 10,
        '& span': {
          color: props.color2
        }
      },
      '& .table': {
        margin: '10px 0px',
      },
      '& .buttonGroup': {
        margin: '0px -10px',
        width: 'calc(100% + 20px)',
      }

    },
    invoiceBox: {
      padding: 10,
      color: '#989898',
      fontWeight: 200,
      fontSize: 13,
      '& .title': {
        fontSize: 20,
        fontWeight: 400,
        marginBottom: 10,
      }
    },
    titleGray: {
      fontSize: 20,
      textTransform: 'uppercase',
      fontWeight: 'normal',
      marginBottom: 10,
      '& span': {
        fontSize: 16,
        fontWeight: 400,
        textTransform: 'capitalize',
      }
    },
  }));
  return styles();
}
export default theme;

